import { RefObject, useEffect, useState } from "react";

export const useHovered = (ref: RefObject<HTMLElement | null>) => {
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (element == null) return;

    const onOver = () => setHovered(true);
    const onOut = () => setHovered(false);
    element.addEventListener("mouseover", onOver);
    element.addEventListener("mouseout", onOut);

    return () => {
      element.removeEventListener("mouseover", onOver);
      element.removeEventListener("mouseout", onOut);
    };
  }, [ref]);

  return hovered;
};
